module.exports = "/assets/0e0b93cf9fd793d0e626a09238c27b24.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/supplier/assets/logos/amadeus.png
// module id = 603
// module chunks = 0